import { render, staticRenderFns } from "./butie.vue?vue&type=template&id=ce85d052&scoped=true"
import script from "./butie.vue?vue&type=script&lang=js"
export * from "./butie.vue?vue&type=script&lang=js"
import style0 from "./butie.vue?vue&type=style&index=0&id=ce85d052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce85d052",
  null
  
)

export default component.exports